const changeBrowserLanguage = language => {
  document.getElementsByTagName('html')[0].setAttribute('lang', language);
};

export default changeBrowserLanguage;
